import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Menu({
  color = colors.gray['600'],
  width = 24,
  height = 24,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25012 7C3.25012 6.58579 3.58591 6.25 4.00012 6.25H20.0001C20.4143 6.25 20.7501 6.58579 20.7501 7C20.7501 7.41421 20.4143 7.75 20.0001 7.75H4.00012C3.58591 7.75 3.25012 7.41421 3.25012 7ZM3.25012 12C3.25012 11.5858 3.58591 11.25 4.00012 11.25L20.0001 11.25C20.4143 11.25 20.7501 11.5858 20.7501 12C20.7501 12.4142 20.4143 12.75 20.0001 12.75L4.00012 12.75C3.58591 12.75 3.25012 12.4142 3.25012 12ZM4.00012 16.25C3.58591 16.25 3.25012 16.5858 3.25012 17C3.25012 17.4142 3.58591 17.75 4.00012 17.75H20.0001C20.4143 17.75 20.7501 17.4142 20.7501 17C20.7501 16.5858 20.4143 16.25 20.0001 16.25H4.00012Z"
        fill={color}
      />
    </svg>
  );
}
